<template>
  <b-container class="header-content">
    <b-row>
      <b-col class="header-content-grid" cols="12" :md="left">
        <h1 id="page-header" v-html="content.content_title"></h1>
        <div id="content-header" v-html="content.content_description"></div>
        <div class="header-button" v-if="link">
          <b-button @click="$router.push('/' + $store.state.selectlanguage + link)" class="btn-magenta">{{
            $store.state.labels.BTN_SEE_PRODUCT }}</b-button>
          &nbsp;
          <b-button @click="contactSales($store.state.configs.brand_email)" class="btn-transparent">{{
            $store.state.labels.BTN_CONTACT_SALES }}</b-button>
        </div>
      </b-col>
      <b-col class="header-content-grid" cols="12" :md="right">
        <b-img-lazy v-bind="mainProps" :src="setImg" :alt="content.content_title"></b-img-lazy>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'HeaderContent',
  props: {
    content: { type: Object, required: true, default: null },
    link: { type: String, required: true, default: null },
    img: { type: String, required: false, default: null },
    left: { type: String, required: false, default: null },
    right: { type: String, required: false, default: null },
  },
  computed: {
    setImg() {
      if (this.img) {
        return this.img;
      } else {
        return this.content.content_image
      }
    }
  },
  data() {
    return {
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: "#bbb",
        width: 600,
        height: 400,
        class: "p-20",
      }
    }
  },
  methods: {
    contactSales(email) {
      window.location = "mailto:" + email;
    },
  },
}
</script>

